import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _class;
import React, { Component } from 'react';
import { observer, engineConfig } from '@alilc/lowcode-editor-core';
import { BorderDetecting } from './border-detecting';
import { BorderContainer } from './border-container';
import { BorderSelecting } from './border-selecting';
import BorderResizing from './border-resizing';
import { InsertionView } from './insertion';
import './bem-tools.less';
import './borders.less';
export var BemTools = observer(_class = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BemTools, _Component);
  function BemTools() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = BemTools.prototype;
  _proto.render = function render() {
    var host = this.props.host;
    var designMode = host.designMode;
    var _host$viewport = host.viewport,
      scrollX = _host$viewport.scrollX,
      scrollY = _host$viewport.scrollY,
      scale = _host$viewport.scale;
    if (designMode === 'live') {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "lc-bem-tools",
      style: {
        transform: "translate(" + -scrollX * scale + "px," + -scrollY * scale + "px)"
      }
    }, !engineConfig.get('disableDetecting') && /*#__PURE__*/React.createElement(BorderDetecting, {
      key: "hovering",
      host: host
    }), /*#__PURE__*/React.createElement(BorderSelecting, {
      key: "selecting",
      host: host
    }), engineConfig.get('enableReactiveContainer') && /*#__PURE__*/React.createElement(BorderContainer, {
      key: "reactive-container-border",
      host: host
    }), /*#__PURE__*/React.createElement(InsertionView, {
      key: "insertion",
      host: host
    }), /*#__PURE__*/React.createElement(BorderResizing, {
      key: "resizing",
      host: host
    }), host.designer.bemToolsManager.getAllBemTools().map(function (tools) {
      var ToolsCls = tools.item;
      return /*#__PURE__*/React.createElement(ToolsCls, {
        key: tools.name,
        host: host
      });
    }));
  };
  return BemTools;
}(Component)) || _class;